import { KeyRound, Tag, RefreshCw, Users } from "lucide-react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal, SectionLabel, Stagger, Item } from "../components/Reveal";
import { FinalCta } from "../components/CTA";

const beliefs = [
  { icon: KeyRound, text: "You should own what you pay for." },
  { icon: Tag, text: "Prices should be published, not negotiated in the dark." },
  { icon: RefreshCw, text: "Building is half the job. Running it every month is the other half." },
  { icon: Users, text: "Small and accountable beats big and unreachable." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO title="About Allcov LLP | Noida" description="Allcov LLP builds and runs the digital and operational backbone of small businesses — brand, website, WhatsApp automation and SOPs." path="/about" />
      <PageHero eyebrow="About Allcov" title="Small-business systems, done properly." testid="about" />

      <section className="py-20 lg:py-28" data-testid="about-story">
        <div className="mx-auto max-w-4xl px-6 lg:px-10">
          <Reveal><SectionLabel>Who We Are</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <div className="space-y-6 text-base leading-relaxed text-mut md:text-lg">
              <p>
                Allcov LLP is a Noida-based company that builds and runs the digital and operational backbone of small businesses: brand, website, WhatsApp automation and SOPs.
              </p>
              <p>
                We started in August 2025. Our founder, Kaushlesh Agarwal, grew up around a family solar business that has run since 1998, and saw how small businesses run on WhatsApp, phone calls and memory. Allcov exists to give them simple systems that work every day.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section-light py-20 lg:py-28" data-testid="about-beliefs">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal><SectionLabel>What We Believe</SectionLabel></Reveal>
          <Stagger className="grid gap-px border border-line bg-line sm:grid-cols-2 lg:grid-cols-4">
            {beliefs.map((b) => (
              <Item key={b.text} className="h-full">
                <div className="flex h-full flex-col gap-5 bg-surface p-7">
                  <b.icon size={24} className="text-pop" strokeWidth={1.5} />
                  <p className="font-batangas text-lg leading-snug tracking-tight">{b.text}</p>
                </div>
              </Item>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="py-20 lg:py-28" data-testid="about-team">
        <div className="mx-auto max-w-4xl px-6 lg:px-10">
          <Reveal><SectionLabel>Team</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <div className="flex items-center gap-5 border border-line bg-surface p-7">
              <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full border border-line bg-base" data-testid="about-founder-photo">
                <span className="font-batangas text-2xl text-pop">KA</span>
              </div>
              <div>
                <p className="font-batangas text-2xl tracking-tight">Kaushlesh Agarwal</p>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-faint">Founder & Designated Partner</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-10 border-t border-line pt-8 text-xs leading-relaxed text-faint" data-testid="about-company-details">
              <p>ALLCOV LLP · LLPIN ACQ-7779 · GSTIN 09ACLFA1029L1Z9 · Udyam-registered MSME</p>
              <p className="mt-2">Registered office: Ground Floor, D-9, Vyapar Marg, Sector 3, Noida, Uttar Pradesh 201301</p>
            </div>
          </Reveal>
        </div>
      </section>

      <FinalCta />
    </div>
  );
}
